import { render, staticRenderFns } from "./IntroductionWithPromo.vue?vue&type=template&id=27c01eae&scoped=true&"
import script from "./IntroductionWithPromo.vue?vue&type=script&lang=js&"
export * from "./IntroductionWithPromo.vue?vue&type=script&lang=js&"
import style0 from "./IntroductionWithPromo.vue?vue&type=style&index=0&id=27c01eae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c01eae",
  null
  
)

export default component.exports